<template>
  <div>
    <table-controls-vue
      v-if="!loading && items.length"
      :has-sticky="true"
      :no-scroll-direction="true"
      classes="is-marginless-bottom">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-small is-last-fixed-small has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <columns-toggles
                :entries="columnsList"
                :source="columns"
                @update="updateColumns">
              </columns-toggles>
            </th>
            <th>
              <span>Date</span>
            </th>
            <th>
              <span>Type</span>
            </th>
            <th>
              <span>Participant</span>
            </th>
            <th>
              <span>Contact</span>
            </th>
            <th v-if="showColumn('guests')">
              <span>Invité(s)</span>
            </th>
            <th v-if="showColumn('author')">
              <span>Organisateur</span>
            </th>
            <th>
              <span>Bilan</span>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tbody class="has-cells-vcentered">
          <tr
            v-for="(rdv, i) in items"
            :key="rdv.pk"
            class="is-size-6"
            :id="'e' + rdv.pk">
            <td class="is-paddingless has-text-centered is-vcentered">
              <span
                v-if="rdv.status !== 'new'"
                :data-tooltip="rdvStatus[rdv.status].label"
                class="dot tooltip is-tooltip-right"
                :class="rdvStatus[rdv.status].color"></span>
            </td>
            <td
              @click="goToDay(rdv.date)"
              class="is-cell-hoverable has-cursor-pointer">
              {{ rdv.date | prettyFullDatetime }}
            </td>
            <td>
              {{ rdv.rdv_type }}
            </td>
            <td class="is-cell-hoverable">
              <!-- <td :class="{'is-cell-hoverable' : isAdmin || (isManager && currentUser.account.pk === rdv.user.account.pk )}"> -->
              <!-- <router-link v-if="isAdmin || (isManager && currentUser.account.pk === rdv.user.account.pk )" :to="{name: 'UserVue', params: {id: rdv.user.pk}}">{{rdv.user.last_name}} {{rdv.user.first_name}}</router-link> -->
              <router-link :to="{name: 'UserVue', params: {id: rdv.user.pk}}">
                {{ rdv.user.last_name }} {{ rdv.user.first_name }}
              </router-link>
            </td>
            <td class="is-cell-hoverable">
              <router-link :to="{name: 'ContactVue', params: {id: rdv.contact.pk}}">
                {{ rdv.contact.last_name }} {{ rdv.contact.first_name }}
              </router-link>
            </td>
            <td :class="{'is-cell-hoverable' : rdv.guests.length >= 1}">
              <span
                v-for="(guest, idx) in rdv.guests"
                :key="guest.pk">
                <router-link :to="{name: 'UserVue', params: {id: guest.pk}}">{{ guest.last_name }} {{ guest.first_name }}</router-link>
                <span v-if="idx + 1 < rdv.guests.length"> - </span><br>
              </span>
            </td>
            <td
              class="is-cell-hoverable"
              v-if="showColumn('author')">
              <router-link :to="{name: 'UserVue', params: {id: rdv.author.pk}}">
                {{ rdv.author.last_name }} {{ rdv.author.first_name }}
              </router-link>
            </td>
            <td>
              <span v-if="rdv.status !== 'new' && rdv.result && 'bilan' in reportBlock[rdv.result] && 'report' in reportBlock[rdv.result]">
                {{ reportBlock[rdv.result].bilan.info }}<span v-if="reportBlock[rdv.result].report"> - {{ reportBlock[rdv.result].report.info }}</span>
              </span>
            </td>
            <td>
              <display-button-list
                :buttons="buttonList"
                :data="rdv"
                :hide-text-when-solo="true"
                :open-up="{'position': i, 'total': items.length}">
              </display-button-list>
            </td>
          </tr>
          <!--<tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
        </tbody>
      </table>
    </table-controls-vue>
    <div v-show="!loading && !items.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucun rendez-vous à afficher
        </h2>
        <a
          class="has-text-primary"
          @click="resetFilters"
          v-if="hasFilter"><span class="icon"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
      </div>
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)"></pagination>
  </div>
</template>

<script>
import { ColumnConf, Quickview, DefaultValues } from '@/mixins'
import moment from 'moment'
const REPORT_BLOCK = {
  not_interested: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact pas intéréssé'
    },
    report: null
  },
  new_rdv: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Nouveau rendez-vous',
      is_link: true
    }
  },
  to_be_continued: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'À suivre',
      is_link: false
    }
  },
  plan_visit: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Rendez-vous visite',
      is_link: true
    }
  },
  sign: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact intéréssé'
    },
    report: {
      entitled: 'Compte rendu',
      info: 'Signature',
      is_link: true
    }
  },
  taxation: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Imposition',
      is_link: false
    }
  },
  age: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Âge',
      is_link: false
    }
  },
  period: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Période',
      is_link: false
    }
  },
  funding: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Financement',
      is_link: false
    }
  },
  no_offer: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Pas d\'offre',
      is_link: false
    }
  },
  other: {
    bilan: {
      entitled: 'Bilan',
      info: 'Contact Hors cible'
    },
    report: {
      entitled: 'Information',
      info: 'Autre',
      is_link: false
    }
  }
}
export default {
  name: 'RdvList',
  filters: {
    rdvStatus (status) {
      let statusLabel = {
        new: '',
        successful: 'Effectué',
        deferred: 'Reporté',
        canceled: 'Annulé'
      }
      return statusLabel[status]
    }
  },
  mixins: [ColumnConf, Quickview, DefaultValues],
  props: {
    items: Array,
    hasFilter: Boolean,
    currentPage: Number,
    totalPage: Number
  },
  data () {
    return {
      deleteTitle: 'Suppression rendez-vous',
      deleteText: 'Le rendez-vous ne sera plus consultable.',
      reportBlock: REPORT_BLOCK,
      loading: false,
      columnsConfResource: 'rdvs',
      buttonList: [
        {
          action: (id, rdv) => {
            this.goToDay(rdv.date)
          },
          icon: 'fa-eye',
          text: 'Voir'
        },
        {
          action: (id, rdv) => {
            this.updateRdv(rdv)
          },
          display: (event) => {
            return this.currentUser.account.pk === event.user.account.pk
          },
          icon: 'fa-edit',
          text: 'Modifier'
        },
        {
          action: (id, rdv) => {
            this.deleteItem(rdv)
          },
          display: (event) => {
            return this.currentUser.account.pk === event.user.account.pk
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer'
        }
      ]
    }
  },
  computed: {
    columnsShow () {
      let columns = {
        guests: { label: 'Invité(s)', mobile: true },
        author: { label: 'Organisateur', mobile: true }
      }
      return columns
    }
  },
  methods: {
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rendez-vous',
        text: 'Le rendez-vous ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteItem (rdv) {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = rdv.pk
        let key = moment(rdv.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.RDV, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'rdvs' })
          this.$emit('loadItems')
          this.$toasted.global.success('Le rendez-vous à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    updateRdv (event) {
      let params = {
        source: event,
        type: 'rdv'
      }
      this.openCalendarNewAction(params)
    },
    goToDay (date) {
      let day = moment(date).format('DD')
      let month = moment(date).format('MM')
      let year = moment(date).format('YYYY')
      this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'rdvs' } })
    },
    resetFilters () {
      this.$emit('resetFilters', event)
    },
    loadItems (event) {
      this.$emit('loadItems', event)
    }
  }
}
</script>
